<template>
    <!--     <van-swipe-cell> -->
    <div class="commonBox" :style="{minHeight: $store.getters.showTabbar ? 'calc(100vh - 50px)' : '100vh'}">
        <div class="leftSoild" v-touch:right="onSwipeRight" @click="handleLetterClick">
        </div>

        <div class="header">
            <img src="../../assets/img/left.png" @click="back" v-if="leftButton">
            <p>{{title}}</p>
            <div v-if="rightButton === 'search'" class="search" @click="showInput ? _showInput() : $emit('Search')">
                <img src="../../assets/img/search.png">
            </div>

            <!--添加图标-->
            <!-- <div v-if="rightButton === 'Add'" class="add" @click="$router.push(path)">
                <img src="../../assets/img/Add.png">
            </div> -->
            <span v-else-if="rightButton && typeof rightButton === 'string'"
                @click="$router.push(path)">{{rightButton}}</span>
            <span class="textItems" v-else-if="rightButton && typeof rightButton !== 'string' && rightButton.length > 1"
                v-for="item in rightButton" @click="$router.push(item.router)">{{item.text}}</span>
        </div>
        <div class="bool" />


        <div class="content">
            <slot />
        </div>

        <div class="searchBox" v-if="!hiddenInput">
            <img src="../../assets/img/search.png" />
            <input type="text" ref="input" @input="_input" />
            <span @click="hiddenEvent">查询</span>
        </div>
        <div v-show="SearchParams===false" :class="AddButton?'searchEditOnAddButtonIsTrue':'searchEdit'"
            @click="_SearchParams">
            <img src="../../assets/img/search.png">
        </div>
        <div v-if="AddButton" class="AddButton" @click="$emit('Other')">
            <img src="../../assets/img/AddButton.png">
        </div>

    </div>
    <!--    <template #left>
             <slot />
        </template>
    </van-swipe-cell> -->
</template>

<script>
    // import {
    //     SwipeCell
    // } from 'vant'
    import touch from 'vue-directive-touch';
    import Vue from 'vue'
    Vue.use(touch);
    export default {
        name: 'commonHeader',
        components: {
            // [SwipeCell.name]:SwipeCell
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            rightButton: {
                type: String | Array,
                default: null
            },
            leftButton: {
                type: String,
                default: 'back'
            },
            path: String,
            showInput: Boolean,
            SearchParams: {
                type: Boolean,
                default: true
            },
            AddButton: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                hiddenInput: true
            }
        },
        mounted() {},
        methods: {
            onSwipeRight() {
                if (!(this.$route.path === '/message' || this.$route.path === '/' || this.$route.path === '/me')) this
                    .$router.go(-1)
            },
            handleLetterClick() {
                console.log('误触区')
            },
            back() {
                if (this.$route.name == "STORE") {
                    this.$store.commit('SET_WAREHOUSELIST', []);
                    this.$store.commit('SET_USER_INFO', {})
                    localStorage.removeItem('userInfo')
                } this.$router.back();
            },
            _showInput() {
                this.hiddenInput = false
                this.$nextTick((x) => { //正确写法
                    this.$refs.input.focus();
                })
            },
            _input() {
                this.$emit('onInput', event.target.value)
            },
            _hiddenInput() {
                this.hiddenInput = true
            },
            _SearchParams() {
                this.$emit('SearchParams')
            },
            hiddenEvent() {
                this.hiddenInput = true;
                this.$Bus.$emit('hiddenEvent');
            }
        }
    }
</script>
<style scoped lang="scss">
    .leftSoild {
        width: 5%;
        height: 100vh;
        position: absolute;
    }

    .commonBox {
        height: auto;
        background: $BACKGROUND-DARK-COLOR;
        padding-bottom: 50px;
        box-sizing: border-box;
    }

    .header {
        height: 106px;
        background: $THEME-COLOR;

        p {
            color: $TEXT-LIGHT-COLOR;
            font-size: 34px;
            font-weight: 400;
        }

        &>img {
            position: absolute;
            left: 8px;
            width: 52px;
            top: 6px;
            padding: 20px
        }

        .search {
            position: absolute;
            width: 98px;
            height: 60px;
            border-radius: 30px;
            background: #037A72;
            text-align: center;
            right: 20px;
            top: 20px;

            img {
                width: 38px;
                margin-top: 11px;
            }
        }

        .add {
            position: absolute;
            width: 98px;
            height: 60px;

            text-align: center;
            right: 20px;
            top: 20px;

            img {
                width: 38px;
                margin-top: 11px;
            }
        }

        span {
            position: absolute;
            right: 8px;
            top: 6px;
            padding: 20px;
            font-size: 34px;
            color: #fff;
            font-weight: 400;
        }

        .textItems {
            font-size: 28px;
            width: 56px;
            top: -10px;

            &:nth-child(3) {
                right: 90px;
            }

            &:nth-child(4) {
                right: 10px;
            }
        }
    }

    .bool {
        position: absolute;
        width: 110%;
        left: -5%;
        top: -50px;
        height: 450px;
        border-radius: 0 0 50% 50%;
        background: $THEME-COLOR;
    }

    .content {
        position: relative;
        padding-top: 108px;
        width: 710px;
        margin: auto;
    }

    .searchBox {
        height: 86px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 20;
        background: $THEME-COLOR;

        img {
            width: 30px;
            height: 30px;
            position: absolute;
            left: 50px;
        }

        input {
            font-size: 29px;
            color: #fff;
            flex: 1;
            background: #337872;
            height: 50px;
            border-radius: 30px;
            text-indent: 70px;

            &::-webkit-input-placeholder {
                color: rgba(255, 255, 255, .35);
            }
        }

        span {
            font-size: 26px;
            color: #fff;
            margin-left: 20px;
        }
    }

    .searchEdit {
        position: fixed;
        width: 98px;
        height: 60px;
        border-radius: 30px;
        background: #037A72;
        text-align: center;
        right: 20px;
        top: 20px;
        z-index: 20;

        img {
            width: 38px;
            margin-top: 11px;
        }
    }

    .searchEditOnAddButtonIsTrue {
        position: fixed;
        width: 98px;
        height: 60px;
        border-radius: 30px;
        background: #037A72;
        text-align: center;
        right: 120px;
        top: 20px;
        z-index: 20;

        img {
            width: 38px;
            margin-top: 11px;
        }
    }

    .AddButton {
        position: fixed;
        width: 98px;
        height: 60px;
        border-radius: 30px;
        background: #037A72;
        text-align: center;
        right: 20px;
        top: 20px;
        z-index: 20;

        img {
            width: 38px;
            margin-top: 11px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commonBox/commonBox.vue